import React, { FC } from 'react';
import LayoutPresentation, { LayoutPresentationProps } from './Layout.Presentation';

const Layout: FC<LayoutPresentationProps> = (props: LayoutPresentationProps) => {
  return <LayoutPresentation {...props} />;
};

export default Layout;
